import React, { FC, SVGProps } from 'react';

const SetPick: FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 200 200"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 1.5,
        }}
        {...props}
    >
        <g transform="matrix(1,0,0,1,-500,0)">
            <g id="Set_Pick" transform="matrix(1,0,0,1,-502,0)">
                <g id="Move" transform="matrix(3.01325,0,0,2.91007,-2582.86,-353.075)">
                    <g transform="matrix(0.898807,0,0,1.08957,128.63,-4.41302)">
                        <path d="M1185,174L1233,133" fill="none" strokeWidth={2.54} />
                    </g>
                    <g transform="matrix(0.326164,0,0,0.326123,1029.23,120.206)">
                        <path d="M610.126,34L661,86.685" fill="none" strokeWidth={7.76} />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default SetPick;
